export const PC_AUTH_COOKIE = 'pc-auth'
